import i18next from "i18next";
import { AddExceptionModal } from "./exception/add-exception-modal";
import { AddWeekModal } from "./week/add-week-modal";
import { EditEventWeekModal } from "./week/edit-event-week-modal";
import { EditWeekModal } from "./week/edit-week-modal";

type TModal =
  | AddWeekModal
  | EditWeekModal
  | EditEventWeekModal
  | AddExceptionModal;

export class ModalManager {
  private modals: { [key: string]: TModal } = {};
  private activeModal: string | null = null;

  // Добавление модального окна
  addModal(id: string, modal: TModal, title?: string) {
    this.modals[id] = modal;
    this.modals[id].popup.modalComponent.label = title || i18next.t($ => $.scheduleBacnet.newWindow);

    return this.modals[id];
  }

  // Удаление модального окна
  removeModal(id: string) {
    if (this.modals[id]) {
      this.modals[id].close();
      delete this.modals[id];
    }
  }

  // Открытие модального окна
  openModal(id: string, params: any = {}) {
    if (this.activeModal && this.activeModal !== id) {
      this.closeModal(this.activeModal); // Закрываем текущее активное окно
    }

    if (this.modals[id]) {
      this.activeModal = id;
      this.modals[id].open(params);
    } else {
      console.error(`Модальное окно с id "${id}" не найдено.`);
    }
  }

  // Закрытие модального окна
  closeModal(id: string) {
    if (this.modals[id]) {
      this.modals[id].close();
      if (this.activeModal === id) {
        this.activeModal = null;
      }
    }
  }

  // Получение модального окна по id
  getModal(id: string): TModal | null {
    return this.modals[id] || null;
  }
}
